import gql from 'graphql-tag';

export default gql`
  query suggestionsLists(
    $bookshopId: ID
    $libraryId: ID
    $onlyUnsolicited: Boolean
    $createdSince: DateTime = null
    $states: [SuggestionsListState!]
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    suggestionsLists(
      first: $first
      last: $last
      after: $after
      before: $before
      filter: {
        createdSince: $createdSince
        bookshopId: $bookshopId
        libraryId: $libraryId
        onlyUnsolicited: $onlyUnsolicited
        states: $states
      }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }

      edges {
        node {
          id
          name
          suggestionsCount
          acceptedSuggestionsCount
          rejectedSuggestionsCount
          project {
            id
            name
            createdAt
            goal
            requirements {
              budget
              keywords
              subjects
            }
            state
          }

          library {
            id
            test
            name
            contact_name
            contact_email
          }
          bookshop {
            id
            test
            name
            contact_name
            contact_email
          }
          createdAt
          state
        }
      }
    }
  }
`;
